<template>
  <div class="row m-0">
    <div class="col-auto pr-0" @click="toggleOpen">
      <div class="row m-0 align-items-center">
        <div class="col-auto p-0">
          <ios-contact-icon />
        </div>
        <div class="col px-1 pb-1">
          {{user.name || user.firstname}}
        </div>
        <div class="col-auto p-0 small" >
          <ios-arrow-down-icon :class="{'oneeighty_degree': isOpen}"/>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="menu_dropdown py-3" v-if="isOpen">
        <div class="row m-0">
          <!-- <div class="col-12 mb-2">
            Profile
          </div> -->
          <div class="col-12 mb-2">
            <router-link @click.native="toggleOpen" to="/orders">Orders</router-link>
          </div>
          <div class="col-12 mb-2" @click="logout">
            <router-link @click.native="toggleOpen" to="/">Log out</router-link>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['user'],
  data () {
    return {
      isOpen: false
    }
  },
  created () {
    window.addEventListener('click', this.close)
  },

  beforeDestroy () {
    window.removeEventListener('click', this.close)
  },
  methods: {
    ...mapActions(['logout']),
    toggleOpen () {
      this.isOpen = !this.isOpen
    },
    close (e) {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false
      }
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>

<style scoped>
  .menu_dropdown {
    position: absolute;
    top: 40px;
    right: 0;
    width: 100%;
    min-width: max-content;
    background-color: var(--light-color-off);
  }
  .dark-mode .menu_dropdown {
    background-color: var(--dark-color);
  }
  .oneeighty_degree {
    transform: rotate(180deg);
  }
</style>
